
import accessoriesSearch from "./search-queries/search-accessories";
import cannabisSearch from "./search-queries/search-cannabis";

export default [cannabisSearch, accessoriesSearch];
